import { SvgLeftButton, SvgQuestionMark, SvgRightButton } from "assets";
import { gray8, white } from "assets/styleUtils";
import { TagList } from "components/TagList";
import { Title } from "components/Title";
import { ToggleBox } from "components/ToggleBox";
import {
  IListDataContent,
  ILocation,
} from "pages/RecommendWeddingHall/RecommendWeddingHall";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { userSelectFittableHall } from "recoil/atoms";
import styles from "./style.module.css";

interface GridProps {
  localList?: ILocation[];
  filterList?: IListDataContent[];
  onClick?: (value: string[]) => void;
  column: number;
  selectedValue?: string[];
  setValue?: (value: string[]) => void;
  selectType: "multi" | "single";
}

function SelectGrid({
  localList,
  filterList,
  column,
  selectType,
  selectedValue,
  setValue,
}: GridProps) {
  const [select, setSelect] = useState<string[]>([]);
  const [selectCity, setSelectCity] = useRecoilState(userSelectFittableHall);
  //location_1
  const handleSelectCity = (item: string, local: string) => {
    setSelectCity((prevState: any) => {
      if (
        (prevState.wantCity || []).some((element: string) =>
          element.includes(local)
        )
      ) {
        return {
          ...prevState,
          wantCity: prevState.wantCity.filter(
            (value: string) => !value.includes(local)
          ),
        };
      } else {
        return {
          ...prevState,
          wantCity: [...prevState.wantCity, `${item}-${local}`],
        };
      }
    });
  };

  const handleSelectMultiItem = (item: string) => {
    if (item === "0" || select.includes("0")) {
      setSelect([]);
    }
    if (select.includes(item)) {
      setSelect((prevState) => prevState.filter((value) => value !== item));
    } else {
      setSelect((prevState) => [...prevState, item]);
    }
  };

  const handleSelectSingleItem = (item: string) => {
    if (select.includes(item)) {
      setSelect([]);
    } else {
      setSelect([item]);
    }
  };

  useEffect(() => {
    setValue?.(select);
  }, [select]);

  useEffect(() => {
    if (setValue && selectedValue) {
      setSelect(selectedValue);
    }
  }, [selectedValue]);

  return (
    <div
      style={{
        marginTop: "45px",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "row",
      }}
    >
      <div
        style={{
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        {(localList || []).map((item, key) => {
          return (
            <div className={styles.wrap}>
              <div key={key} className={styles.title}>
                {item.location_2.length > 0 ? item.location_1 : null}
              </div>

              <div
                className={styles.list}
                style={{ gridTemplateColumns: `repeat(${column}, 1fr)` }}
              >
                {item.location_2.length > 0
                  ? item.location_2.map((local, key) => {
                      return (
                        <button
                          key={key}
                          type="button"
                          className={
                            select?.includes(local) ? styles.selectedItem : ""
                          }
                          onClick={() => {
                            handleSelectMultiItem(local),
                              handleSelectCity(item.location_1, local);
                          }}
                        >
                          {local}
                        </button>
                      );
                    })
                  : null}
              </div>
            </div>
          );
        })}
        <div
          className={styles.list}
          style={{ gridTemplateColumns: `repeat(${column}, 1fr)` }}
        >
          {(filterList || []).length > 1 &&
            (filterList || []).map((item, key) => {
              if (item.content === "X") {
                return;
              } else {
                return (
                  <button
                    key={key}
                    type="button"
                    className={
                      select?.includes(String(item.no))
                        ? styles.selectedItem
                        : ""
                    }
                    onClick={() =>
                      selectType === "multi"
                        ? handleSelectMultiItem(String(item.no))
                        : handleSelectSingleItem(String(item.no))
                    }
                  >
                    {item.content}
                  </button>
                );
              }
            })}
        </div>
      </div>
    </div>
  );
}

interface Props {
  title: string;
  subTitle: string;
  localList?: ILocation[];
  filterList?: IListDataContent[];
  page: number;
  setPage: (page: number) => void;
  selectedValue?: string[];
  setValue?: (value: string[]) => void;
  column: number;
  desc?: string;
  selectType: "multi" | "single";
}

export default function SelectBox({
  title,
  subTitle,
  localList,
  filterList,
  page,
  setPage,
  setValue,
  selectedValue,
  column,
  desc,
  selectType,
}: Props) {
  const navigate = useNavigate();
  const anyType: IListDataContent[] = [
    {
      no: "0",
      type: (filterList || [])[0]?.type || "",
      content: "상관없음",
      ordering: 0,
      del_yn: "N",
      createdAt: "",
      updatedAt: "",
    },
  ];
  let recombinationList;
  switch (true) {
    case title.includes("웨딩홀"):
      recombinationList = [
        {
          content: "컨벤션",
          no: "1",
          ordering: 1,
          type: "hall_type",
        },
        {
          content: "채플",
          no: "2",
          ordering: 2,
          type: "hall_type",
        },
        {
          content: "호텔",
          no: ["3", "4"],
          ordering: 3,
          type: "hall_type",
        },
        {
          content: "하우스",
          no: ["5", "6", "7"],
          ordering: 5,
          type: "hall_type",
        },
      ];
      break;
    case title.includes("식사"):
      recombinationList = [
        {
          content: "뷔페식",
          no: "35",
          ordering: 1,
          type: "meal_type",
        },
        {
          content: "코스식",
          no: ["36", "37", "38", "39"],
          ordering: 2,
          type: "meal_type",
        },
      ];
      break;
    case title.includes("간격"):
      recombinationList = [
        {
          content: "120분 이하",
          no: ["17", "18", "19"],
          ordering: 1,
          type: "hall_term",
        },
        {
          content: "180분 이상",
          no: ["20", "21", "22", "23"],
          ordering: 2,
          type: "hall_term",
        },
      ];
      break;
    default:
      recombinationList = filterList;
  }
  const combinedList: IListDataContent[] = (recombinationList || []).concat(
    ...anyType
  );
  return (
    <div className={styles.container}>
      <div>
        <Title title={title} subTitle={subTitle} />
        {desc ? (
          <div className={styles.flexCenter}>
            <div className={`${styles.flexCenter} ${styles.decsStyle}`}>
              <div style={{ marginBottom: "8px" }}>
                <SvgQuestionMark />
              </div>

              <div
                dangerouslySetInnerHTML={{ __html: desc }}
                style={{ lineHeight: "160%" }}
              />
            </div>
          </div>
        ) : null}
        <SelectGrid
          column={column}
          localList={localList}
          filterList={combinedList}
          selectedValue={selectedValue}
          setValue={setValue}
          selectType={selectType}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "40px",
        }}
      >
        {page > 1 ? (
          <div style={{ cursor: "pointer" }} onClick={() => setPage(page - 1)}>
            <SvgLeftButton style={{ cursor: "pointer" }} />
          </div>
        ) : (
          <div></div>
        )}
        <div
          style={{ cursor: "pointer" }}
          onClick={() =>
            (selectedValue || []).length > 0
              ? page === 6
                ? navigate("/wedding/hall?txt=recommend")
                : setPage(page + 1)
              : null
          }
        >
          <SvgRightButton
            color={`rgba(121, 197, 188, ${
              (selectedValue || []).length > 0 ? 1 : 0.5
            })`}
          />
        </div>
      </div>
    </div>
  );
}
